webpackJsonp([18],{

/***/ 106:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return USER_LOGOUT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return USER_LOGOUT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return USER_LOGOUT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return USER_LOGIN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return USER_LOGIN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return USER_LOGIN_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return USER_REGISTER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return USER_REGISTER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return USER_REGISTER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CHANGE_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return EDIT_PROFILE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return EDIT_PROFILE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return EDIT_PROFILE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return PAGE_UNLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DEACTIVATE; });
/* unused harmony export PACKAGE_SINGLE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return PACKAGE_MULTI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return ROLE_SUPER_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ROLE_EXECUTIVE_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return ROLE_SUBSCRIBERS_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return ROLE_MULTI_PACK_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return ROLE_SINGLE_PACK_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return ROLE_TRIAL_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return EXPIRED_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return RoleMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return QUERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CHANGE_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return MonthEnum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AgeEnum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AgeColors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActivityType; });
var _RoleMap;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable import/prefer-default-export */

var USER_LOGOUT_REQUEST = 'USER_LOGOUT_REQUEST';
var USER_LOGOUT_SUCCESS = 'USER_LOGOUT_SUCCESS';
var USER_LOGOUT_FAILURE = 'USER_LOGOUT_FAILURE';
var USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST';
var USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
var USER_LOGIN_FAILURE = 'USER_LOGIN_FAILURE';
var USER_REGISTER_REQUEST = 'USER_REGISTER_REQUEST';
var USER_REGISTER_SUCCESS = 'USER_REGISTER_SUCCESS';
var USER_REGISTER_FAILURE = 'USER_REGISTER_FAILURE';
var CHANGE_FORM = 'CHANGE_FORM';
var EDIT_PROFILE_REQUEST = 'EDIT_PROFILE_REQUEST';
var EDIT_PROFILE_SUCCESS = 'EDIT_PROFILE_SUCCESS';
var EDIT_PROFILE_FAILURE = 'EDIT_PROFILE_FAILURE';
var PAGE_UNLOAD = 'PAGE_UNLOAD';
var DEACTIVATE = 'DEACTIVATE';
var PACKAGE_SINGLE = 1;
var PACKAGE_MULTI = 2;
var ROLE_SUPER_ADMIN = 1;
var ROLE_EXECUTIVE_ADMIN = 2;
var ROLE_SUBSCRIBERS_ADMIN = 3;
var ROLE_MULTI_PACK_USER = 4;
var ROLE_SINGLE_PACK_USER = 5;
var ROLE_TRIAL_USER = 6;
var EXPIRED_USER = 7;
var RoleMap = (_RoleMap = {}, _defineProperty(_RoleMap, ROLE_SUPER_ADMIN, 'SUPER_ADMIN'), _defineProperty(_RoleMap, ROLE_EXECUTIVE_ADMIN, 'EXECUTIVE_ADMIN'), _defineProperty(_RoleMap, ROLE_SUBSCRIBERS_ADMIN, 'SUBSCRIBERS_ADMIN'), _defineProperty(_RoleMap, ROLE_MULTI_PACK_USER, 'MULTI_PACK_USER'), _defineProperty(_RoleMap, ROLE_SINGLE_PACK_USER, 'SINGLE_PACK_USER'), _defineProperty(_RoleMap, ROLE_TRIAL_USER, 'TRIAL_USER'), _defineProperty(_RoleMap, EXPIRED_USER, 'EXPIRED_USER'), _RoleMap);
var QUERY = 'QUERY';
var CHANGE_PATH = 'CHANGE_PATH';
var MonthEnum = {
  JANUARY: 'January',
  FEBRUARY: 'February',
  MARCH: 'March',
  APRIL: 'April',
  MAY: 'May',
  JUNE: 'June',
  JULY: 'July',
  AUGUST: 'August',
  SEPTEMBER: 'September',
  OCTOBER: 'October',
  NOVEMBER: 'November',
  DECEMBER: 'December'
};
var AgeEnum = {
  IT: '1-3 IT',
  PSC: '3-5 PSC/GD',
  OSC: '5-10 OSC'
};

var AgeColors = {
  IT: '#E67E69',
  PSC: '#00B2A6',
  OSC: '#EFCA75',
  ALL: '#E02F2F'
};

var ActivityType = {
  DAILY: 'daily',
  PROJECT: 'project'
};

/***/ }),

/***/ 255:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__);


// Navigation manager, e.g. history.push('/home')
// https://github.com/mjackson/history
/* harmony default export */ __webpack_exports__["a"] = (true && __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default()());

/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(264);
module.exports = __webpack_require__(466);


/***/ }),

/***/ 466:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/whatwg-fetch/fetch.js
var fetch = __webpack_require__(203);
var fetch_default = /*#__PURE__*/__webpack_require__.n(fetch);

// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(81);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(254);
var react_dom_default = /*#__PURE__*/__webpack_require__.n(react_dom);

// EXTERNAL MODULE: ./node_modules/react-deep-force-update/lib/index.js
var lib = __webpack_require__(551);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(552);
var query_string_default = /*#__PURE__*/__webpack_require__.n(query_string);

// EXTERNAL MODULE: ./node_modules/history/PathUtils.js
var PathUtils = __webpack_require__(153);
var PathUtils_default = /*#__PURE__*/__webpack_require__.n(PathUtils);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(107);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(253);

// CONCATENATED MODULE: ./src/components/App.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var ContextType = _extends({
  // Enables critical path CSS rendering
  // https://github.com/kriasoft/isomorphic-style-loader
  insertCss: prop_types_default.a.func.isRequired,
  // Universal HTTP client
  fetch: prop_types_default.a.func.isRequired
}, es["Provider"].childContextTypes);

/**
 * The top-level React component setting context (global) variables
 * that can be accessed from all the child components.
 *
 * https://facebook.github.io/react/docs/context.html
 *
 * Usage example:
 *
 *   const context = {
 *     history: createBrowserHistory(),
 *     store: createStore(),
 *   };
 *
 *   ReactDOM.render(
 *     <App context={context}>
 *       <Layout>
 *         <LandingPage />
 *       </Layout>
 *     </App>,
 *     container,
 *   );
 */

var App_App = function (_React$PureComponent) {
  _inherits(App, _React$PureComponent);

  function App() {
    _classCallCheck(this, App);

    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
  }

  _createClass(App, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return this.props.context;
    }
  }, {
    key: 'render',
    value: function render() {
      // NOTE: If you need to add or modify header, footer etc. of the app,
      // please do that inside the Layout component.
      return react_default.a.Children.only(this.props.children);
    }
  }]);

  return App;
}(react_default.a.PureComponent);

App_App.childContextTypes = ContextType;


/* harmony default export */ var components_App = (App_App);
// CONCATENATED MODULE: ./src/createFetch.js
var createFetch__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Creates a wrapper function around the HTML5 Fetch API that provides
 * default arguments to fetch(...) and is intended to reduce the amount
 * of boilerplate code in the application.
 * https://developer.mozilla.org/docs/Web/API/Fetch_API/Using_Fetch
 */
function createFetch(fetch, _ref) {
  var baseUrl = _ref.baseUrl,
      cookie = _ref.cookie;

  // NOTE: Tweak the default options to suite your application needs
  var defaults = {
    method: 'POST', // handy with GraphQL backends
    mode: baseUrl ? 'cors' : 'same-origin',
    credentials: baseUrl ? 'include' : 'same-origin',
    headers: createFetch__extends({
      Accept: 'application/json'
    }, cookie ? { Cookie: cookie } : null)
  };

  return function (url, options) {
    if (options.headers && options.headers['Content-Type'] === 'multipart/form-data') {
      delete options.headers['Content-Type'];
      delete defaults.headers['Content-Type'];
    } else {
      defaults.headers['Content-Type'] = 'application/json';
    }

    return url.startsWith('/graphql') || url.startsWith('/api') ? fetch('' + baseUrl + url, createFetch__extends({}, defaults, options, {
      headers: createFetch__extends({}, defaults.headers, options && options.headers)
    })) : fetch(url, options);
  };
}

/* harmony default export */ var src_createFetch = (createFetch);
// EXTERNAL MODULE: ./node_modules/redux/es/index.js + 6 modules
var redux_es = __webpack_require__(154);

// EXTERNAL MODULE: ./node_modules/redux-thunk/lib/index.js
var redux_thunk_lib = __webpack_require__(559);
var redux_thunk_lib_default = /*#__PURE__*/__webpack_require__.n(redux_thunk_lib);

// EXTERNAL MODULE: ./node_modules/redux-api-middleware/lib/index.js
var redux_api_middleware_lib = __webpack_require__(252);
var redux_api_middleware_lib_default = /*#__PURE__*/__webpack_require__.n(redux_api_middleware_lib);

// EXTERNAL MODULE: ./src/constants/index.js
var constants = __webpack_require__(106);

// CONCATENATED MODULE: ./src/reducers/auth.js
var auth__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var auth_initialState = {
  formState: {
    username: '',
    password: '',
    firstName: '',
    lastName: '',
    gender: '',
    phone: '',
    address: '',
    billing_address: '',
    image: ''
  },
  errorMessage: '',
  isFetching: false,
  user: {},
  package: {}
};

/* harmony default export */ var auth = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : auth_initialState;
  var action = arguments[1];

  switch (action.type) {
    case constants["z" /* USER_LOGOUT_REQUEST */]:
      return auth__extends({}, state, { isFetching: true, formState: auth_initialState.formState });
    case constants["A" /* USER_LOGOUT_SUCCESS */]:
      return auth_initialState;
    case constants["y" /* USER_LOGOUT_FAILURE */]:
      return auth__extends({}, state, { isFetching: false, errorMessage: action.payload });
    case constants["w" /* USER_LOGIN_REQUEST */]:
      return auth__extends({}, state, { isFetching: true, formState: auth_initialState.formState });
    case constants["x" /* USER_LOGIN_SUCCESS */]:
      return auth__extends({}, state, {
        isFetching: false,
        user: action.payload.user,
        package: action.payload.package,
        errorMessage: ''
      });
    case constants["v" /* USER_LOGIN_FAILURE */]:
      return auth__extends({}, state, {
        isFetching: false,
        errorMessage: action.payload.response.errorMessage
      });
    case constants["C" /* USER_REGISTER_REQUEST */]:
      return auth__extends({}, state, { isFetching: true, formState: auth_initialState.formState });
    case constants["D" /* USER_REGISTER_SUCCESS */]:
      return auth__extends({}, state, { isFetching: false, errorMessage: '' });
    case constants["B" /* USER_REGISTER_FAILURE */]:
      return auth__extends({}, state, {
        isFetching: false,
        errorMessage: action.payload.response.errorMessage
      });
    case constants["d" /* CHANGE_FORM */]:
      return auth__extends({}, state, { formState: action.newState });
    case constants["h" /* EDIT_PROFILE_REQUEST */]:
      return auth__extends({}, state, { isFetching: true, formState: auth_initialState.formState });
    case constants["i" /* EDIT_PROFILE_SUCCESS */]:
      return auth__extends({}, state, {
        isFetching: false,
        user: action.payload.user,
        errorMessage: ''
      });
    case constants["g" /* EDIT_PROFILE_FAILURE */]:
      return auth__extends({}, state, {
        isFetching: false,
        errorMessage: action.payload.response.errorMessage
      });
    case constants["m" /* PAGE_UNLOAD */]:
      return auth__extends({}, auth_initialState, { user: state.user, package: state.package });
    case constants["f" /* DEACTIVATE */]:
      return auth_initialState;
    default:
      return state;
  }
});
// CONCATENATED MODULE: ./src/reducers/path.js
var path__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var path_initialState = {
  path: ''
};

/* harmony default export */ var path = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : path_initialState;
  var action = arguments[1];

  switch (action.type) {
    case constants["e" /* CHANGE_PATH */]:
      return path__extends({}, state, { path: action.path });
    default:
      return state;
  }
});
// CONCATENATED MODULE: ./src/reducers/pageProperties.js
var pageProperties__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var pageProperties_initialState = {
  query: ''
};

/* harmony default export */ var pageProperties = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : pageProperties_initialState;
  var action = arguments[1];

  switch (action.type) {
    case constants["n" /* QUERY */]:
      return pageProperties__extends({}, state, { query: action.query });
    default:
      return state;
  }
});
// CONCATENATED MODULE: ./src/reducers/index.js





/* harmony default export */ var reducers = (Object(redux_es["c" /* combineReducers */])({
  auth: auth,
  path: path,
  pageProperties: pageProperties
}));
// CONCATENATED MODULE: ./src/store/createHelpers.js
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function createGraphqlRequest(fetch) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(query, variables) {
      var fetchConfig, resp;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              fetchConfig = {
                method: 'post',
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ query: query, variables: variables }),
                credentials: 'include'
              };
              _context.next = 3;
              return fetch('/graphql', fetchConfig);

            case 3:
              resp = _context.sent;

              if (!(resp.status !== 200)) {
                _context.next = 6;
                break;
              }

              throw new Error(resp.statusText);

            case 6:
              return _context.abrupt('return', resp.json());

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function graphqlRequest(_x, _x2) {
      return _ref.apply(this, arguments);
    }

    return graphqlRequest;
  }();
}

function createHelpers(_ref2) {
  var fetch = _ref2.fetch,
      history = _ref2.history;

  return {
    fetch: fetch,
    history: history,
    graphqlRequest: createGraphqlRequest(fetch)
  };
}
// EXTERNAL MODULE: ./node_modules/redux-logger/dist/redux-logger.js
var redux_logger = __webpack_require__(608);
var redux_logger_default = /*#__PURE__*/__webpack_require__.n(redux_logger);

// CONCATENATED MODULE: ./src/store/logger/logger.client.js


function logger_client_createLogger() {
  return Object(redux_logger["createLogger"])({
    collapsed: true
  });
}
// CONCATENATED MODULE: ./src/store/configureStore.js







function configureStore(initialState, helpersConfig) {
  var helpers = createHelpers(helpersConfig);
  var middleware = [redux_thunk_lib_default.a.withExtraArgument(helpers)];

  var enhancer = void 0;

  middleware.push(redux_api_middleware_lib["apiMiddleware"]);

  if (false) {
    middleware.push(createLogger());

    // https://github.com/zalmoxisus/redux-devtools-extension#redux-devtools-extension
    var devToolsExtension = function devToolsExtension(f) {
      return f;
    };
    if (process.env.BROWSER && window.devToolsExtension) {
      devToolsExtension = window.devToolsExtension();
    }

    enhancer = compose(applyMiddleware.apply(undefined, middleware), devToolsExtension);
  } else {
    enhancer = redux_es["a" /* applyMiddleware */].apply(undefined, middleware);
  }

  // See https://github.com/rackt/redux/releases/tag/v3.1.0
  var store = Object(redux_es["d" /* createStore */])(reducers, initialState, enhancer);

  // Hot reload reducers (requires Webpack or Browserify HMR to be enabled)
  if (false) {
    module.hot.accept('../reducers', function () {
      return (
        // eslint-disable-next-line global-require
        store.replaceReducer(require('../reducers').default)
      );
    });
  }

  return store;
}
// EXTERNAL MODULE: ./src/history.js
var src_history = __webpack_require__(255);

// CONCATENATED MODULE: ./src/DOMUtils.js
function updateTag(tagName, keyName, keyValue, attrName, attrValue) {
  var node = document.head.querySelector(tagName + '[' + keyName + '="' + keyValue + '"]');
  if (node && node.getAttribute(attrName) === attrValue) return;

  // Remove and create a new tag in order to make it work with bookmarks in Safari
  if (node) {
    node.parentNode.removeChild(node);
  }
  if (typeof attrValue === 'string') {
    var nextNode = document.createElement(tagName);
    nextNode.setAttribute(keyName, keyValue);
    nextNode.setAttribute(attrName, attrValue);
    document.head.appendChild(nextNode);
  }
}

function updateMeta(name, content) {
  updateTag('meta', 'name', name, 'content', content);
}

function updateCustomMeta(property, content) {
  updateTag('meta', 'property', property, 'content', content);
}

function updateLink(rel, href) {
  updateTag('link', 'rel', rel, 'href', href);
}
// EXTERNAL MODULE: ./node_modules/universal-router/browser.js
var browser = __webpack_require__(615);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);

// CONCATENATED MODULE: ./src/routes/index.js
function routes__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/* eslint-disable global-require */

// The top-level (parent) route
var routes = {
  path: '/',

  // Keep in mind, routes are evaluated in order
  children: [{
    path: '/',
    load: function load() {
      return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 1478));
    }
  }, {
    path: '/home',
    load: function load() {
      return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1479));
    }
  }, {
    path: '/forget-password',
    children: [{
      path: '/',
      load: function load() {
        return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1480));
      }
    }, {
      path: '/:id',
      load: function load() {
        return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1480));
      }
    }]
  }, {
    path: '/contact',
    load: function load() {
      return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 1481));
    }
  }, {
    path: '/login',
    load: function load() {
      return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 1482));
    }
  }, {
    path: '/register',
    load: function load() {
      return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 1483));
    }
  }, {
    path: '/about',
    load: function load() {
      return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 1484));
    }
  }, {
    path: '/howto',
    load: function load() {
      return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 1485));
    }
  }, {
    path: '/videos',
    load: function load() {
      return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1486));
    }
  }, {
    path: '/profile',
    load: function load() {
      return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1487));
    }
  }, {
    path: '/app',
    load: function load() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1488));
    }
  }, {
    path: '/payment-response',
    load: function load() {
      return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 1489));
    }
  }, {
    path: '/policy',
    load: function load() {
      return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 1490));
    }
  }, {
    path: '/activity',
    children: [{
      path: '/',
      load: function load() {
        return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1491));
      }
    }, {
      path: '/:id',
      load: function load() {
        return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1492));
      }
    }]
  }, {
    path: '/project',
    children: [{
      path: '/',
      load: function load() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1493));
      }
    }, {
      path: '/:id',
      load: function load() {
        return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1494));
      }
    }]
  },
  // Wildcard routes, e.g. { path: '*', ... } (must go last)
  {
    path: '*',
    load: function load() {
      return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 1495));
    }
  }],

  action: function action(_ref) {
    var _this = this;

    var next = _ref.next;
    return routes__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var route;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return next();

            case 2:
              route = _context.sent;


              // Provide default values for title, description etc.
              route.title = route.title || 'PPCMS';
              route.description = route.description || '';

              return _context.abrupt('return', route);

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
};

// The error page is available by permanent url for development mode
if (false) {
  routes.children.unshift({
    path: '/error',
    action: require('./error').default
  });
}

/* harmony default export */ var src_routes = (routes);
// CONCATENATED MODULE: ./src/router.js



/* harmony default export */ var router = (new browser_default.a(src_routes, {
  resolveRoute: function resolveRoute(context, params) {
    if (typeof context.route.load === 'function') {
      return context.route.load().then(function (action) {
        return action.default(context, params);
      });
    }
    if (typeof context.route.action === 'function') {
      return context.route.action(context, params);
    }
    return null;
  }
}));
// CONCATENATED MODULE: ./src/client.js
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var client__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Re-render the app when window.location changes
var onLocationChange = function () {
  var _ref = client__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(location, action) {
    var route;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // Remember the latest scroll position for the previous location
            scrollPositionsHistory[currentLocation.key] = {
              scrollX: window.pageXOffset,
              scrollY: window.pageYOffset
            };
            // Delete stored scroll position for next page if any
            if (action === 'PUSH') {
              delete scrollPositionsHistory[location.key];
            }
            currentLocation = location;

            _context.prev = 3;
            _context.next = 6;
            return router.resolve(client__extends({}, context, {
              path: location.pathname,
              query: query_string_default.a.parse(location.search)
            }));

          case 6:
            route = _context.sent;

            if (!(currentLocation.key !== location.key)) {
              _context.next = 9;
              break;
            }

            return _context.abrupt('return');

          case 9:
            if (!route.redirect) {
              _context.next = 12;
              break;
            }

            src_history["a" /* default */].replace(route.redirect);
            return _context.abrupt('return');

          case 12:

            appInstance = react_dom_default.a.render(_jsx(components_App, {
              context: context
            }, void 0, route.component), container, function () {
              return onRenderComplete(route, location);
            });
            _context.next = 21;
            break;

          case 15:
            _context.prev = 15;
            _context.t0 = _context['catch'](3);

            if (true) {
              _context.next = 19;
              break;
            }

            throw _context.t0;

          case 19:

            console.error(_context.t0);

            // Do a full page reload if error occurs during client-side navigation
            if (action && currentLocation.key === location.key) {
              window.location.reload();
            }

          case 21:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[3, 15]]);
  }));

  return function onLocationChange(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

// Handle client-side navigation by using HTML5 History API
// For more information visit https://github.com/mjackson/history#readme


function client__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }














/* eslint-disable global-require */

// Global (context) variables that can be easily accessed from any React component
// https://facebook.github.io/react/docs/context.html
var context = {
  // Enables critical path CSS rendering
  // https://github.com/kriasoft/isomorphic-style-loader
  insertCss: function insertCss() {
    for (var _len = arguments.length, styles = Array(_len), _key = 0; _key < _len; _key++) {
      styles[_key] = arguments[_key];
    }

    // eslint-disable-next-line no-underscore-dangle
    var removeCss = styles.map(function (x) {
      return x._insertCss();
    });
    return function () {
      removeCss.forEach(function (f) {
        return f();
      });
    };
  },
  // Universal HTTP client
  fetch: src_createFetch(self.fetch, {
    baseUrl: window.App.apiUrl
  }),
  // Initialize a new Redux store
  // http://redux.js.org/docs/basics/UsageWithReact.html
  store: configureStore(window.App.state, { history: src_history["a" /* default */] }),
  storeSubscription: null
};

// Switch off the native scroll restoration behavior and handle it manually
// https://developers.google.com/web/updates/2015/09/history-api-scroll-restoration
var scrollPositionsHistory = {};
if (window.history && 'scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

var onRenderComplete = function initialRenderComplete() {
  var elem = document.getElementById('css');
  if (elem) elem.parentNode.removeChild(elem);
  onRenderComplete = function renderComplete(route, location) {
    document.title = route.title;

    updateMeta('description', route.description);
    // Update necessary tags in <head> at runtime here, ie:
    // updateMeta('keywords', route.keywords);
    // updateCustomMeta('og:url', route.canonicalUrl);
    // updateCustomMeta('og:image', route.imageUrl);
    // updateLink('canonical', route.canonicalUrl);
    // etc.

    var scrollX = 0;
    var scrollY = 0;
    var pos = scrollPositionsHistory[location.key];
    if (pos) {
      scrollX = pos.scrollX;
      scrollY = pos.scrollY;
    } else {
      var targetHash = location.hash.substr(1);
      if (targetHash) {
        var target = document.getElementById(targetHash);
        if (target) {
          scrollY = window.pageYOffset + target.getBoundingClientRect().top;
        }
      }
    }

    // Restore the scroll position if it was saved into the state
    // or scroll to the given #hash anchor
    // or scroll to top of the page
    window.scrollTo(scrollX, scrollY);

    // Google Analytics tracking. Don't send 'pageview' event after
    // the initial rendering, as it was already sent
    if (window.ga) {
      window.ga('send', 'pageview', Object(PathUtils["createPath"])(location));
    }
  };
};

var container = document.getElementById('app');
var appInstance = void 0;
var currentLocation = src_history["a" /* default */].location;src_history["a" /* default */].listen(onLocationChange);
onLocationChange(currentLocation);

// Enable Hot Module Replacement (HMR)
if (false) {
  module.hot.accept('./router', function () {
    if (appInstance) {
      // Force-update the whole tree, including components that refuse to update
      deepForceUpdate(appInstance);
    }

    onLocationChange(currentLocation);
  });
}

/***/ })

},[263]);


// WEBPACK FOOTER //
// client.2b0fa13e.js